import { VotingConstants } from "../../constants/voting.constants";

export const votingDeleting = () => {
	return {
		type: VotingConstants.VOTING_DELETING,
	};
};

export const votingDeleted = () => {
	return {
		type: VotingConstants.VOTING_DELETED,
	};
};
